export const DEFAULT_CONNECTIONS_GAME_DATA = {
  "Category 1": ["Word 1", "Word 2", "Word 3", "Word 4"],
  "Category 2": ["Word 5", "Word 6", "Word 7", "Word 8"],
  "Category 3": ["Word 9", "Word 10", "Word 11", "Word 12"],
  "Category 4": ["Word 13", "Word 14", "Word 15", "Word 16"],
};

export const DEFAULT_CONNECTIONS_INTRO = {
  title: "Connections Game",
  instructions: "Find groups of four words that share a connection.",
  howTo:
    "Select 4 cards that you think share a connection. When you have selected 4 cards, press Submit to check your answer. When you submit a group correctly, the cards are cleared and the connection is revealed. Correctly submit all 4 groups of cards for a chance to win!",
};

export const DEFAULT_CONNECTIONS_FORM_FIELDS = {
  introMessage: DEFAULT_CONNECTIONS_INTRO,
  gameData: DEFAULT_CONNECTIONS_GAME_DATA,
  terms: "",
  termsType: "none",
  makeGradient: false,
  backgroundColor: "#FFFFFF",
  backgroundImage: "",
  bannerImage: "",
  textColor: "#000000",
  buttonColor: "#000000",
  categoryColors: ["#DE183B", "#60116A", "#333333", "#666666"],
  cardBackgroundColor: "#FFFFFF",
  cardTextColor: "#000000",
  categoryTextColor: "#FFFFFF",
  successMessage: "Congratulations, you got it!",
  redirectButtonText: "Click to enter for a chance to win!",
  redirectButtonLink: "",
  redirectButtonColor: "#DE183B",
  reveal: {
    title: "Congratulations!",
    src: "",
    description: "You completed the game!",
  },
};
